// extracted by mini-css-extract-plugin
module.exports = {"gallery":"gallerySmall-module--gallery--1LLRo","gallery_container":"gallerySmall-module--gallery_container--vZHFP"};